<template>
  <div id="itembank">
    <!-- begin breadcrumb -->
    <ol class="breadcrumb pull-right">
      <li><router-link :to="{path: '/'}">Home</router-link></li>
      <li>Tryout</li>
      <li class="active">Daftar Tryout</li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">Daftar Tryout</h1>
    <!-- end page-header -->
    <div class="row">
      <div class="col-md-12">
        <!-- begin panel -->
        <div class="panel panel-inverse">
          <div class="panel-heading">
            <div class="btn-group pull-right">
				<button type="button" class="btn btn-success btn-xs" @click="importTryout()"><span class="fa fa-download"></span> Import Tryout</button>
				&nbsp;
              	<button type="button" class="btn btn-success btn-xs" @click="createTryout()"><span class="fa fa-plus"></span> Tryout</button>
            </div>
            <h4 class="panel-title">Tryout</h4>
          </div>
          <div class="panel-body">
            <app-datatable
              :items="tryouts"
              :headers="headers"
              :has-action="false"
              :has-custom-pagination="true"
			        :has-custom-search="true"
              :custom-pagination-current-page="pagination.currentPage"
              :custom-pagination-per-page="pagination.perPage"
              :custom-pagination-total-pages="pagination.totalPages"
              :custom-pagination-sort-mode="pagination.sortMode"

              v-on:selected="selectedRow = $event"
              v-on:dblClicked="editTryout()"
              v-on:export="exportTryout($event)"
              v-on:generateTO="generateTryout($event)"
              v-on:revisiTO="revisiTryout($event)"
              v-on:changePage="pagination = {...pagination, currentPage: $event}"
							v-on:changeSortMode="pagination = {...pagination, sortMode: $event}"
							v-on:doSearch="search = {query: $event.value, by: headersKey[$event.key]}"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TryoutService from '@/services/tryout.js'
import DataTable from '@/components/plugins/DataTable'
import Moment from 'moment'
import Modal from '@/components/plugins/Modal'

export default {
	name: 'tryout',
	components: {
		'app-datatable': DataTable,
		'app-modal': Modal
	},
	data: function () {
		return {
			tryouts: [],
			selectedRow: null,
			search: null,
			exportModal: false,
			pagination: {
				perPage: 25,
				currentPage: 1,
				totalPages: 0,
				sortMode: 'desc',
			},
			headers: ['Code', 'Nama', 'Jenis', 'Jenjang', 'Tipe', 'Kategori', 'Subtests', 'Jml. Soal', 'Durasi (Menit)', 'Status', 'Created At', 'Action'],
			headersKey: ['code', 'name', 'isRepeated', 'level', 'type', 'category', 'subtests', 'itemCount', 'duration', 'status', 'createdAt'], // camel case for matching search with API
		}
	},
	watch: {
		pagination: function () {
			this.fetchData()
		},
	},
	mounted: function () {
		this.fetchData()
	},
	methods: {
		fetchData: function () {
			var context = this
			var search = this.search
			var pagination = {
				perPage: this.pagination.perPage,
				currentPage: this.pagination.currentPage,
				sortMode: this.pagination.sortMode
			}

			TryoutService.getListTryout(pagination, search, function (result) {
				context.tryouts = []

				if (result.success) {

					result.data.forEach(function (tryout) {
						var subtests = []
						var count = 0
						tryout.subtests.forEach(function (subtest) {
							subtests.push(subtest.subject_name);
							count += subtest.item_count
						})

						var createdAt = Moment(tryout.created_at).format('YYYY-MM-DD')
						var jenis = tryout.is_repeated ? "INSTANT" : "BERAGENDA"
						var row = {
							id: tryout.id,
							data: [
								tryout.code,
								tryout.name,
								jenis,
								tryout.level,
								tryout.type,
                tryout.category,
								subtests.join(', '),
								count,
								tryout.duration,
								tryout.status,
								createdAt
							],
              actions: [{text: 'Export', command: 'export', style: 'btn-danger'}]
						}

            if (tryout.status == 'REVIEW') {
              row.actions.push({text: 'Generate TO', command: 'generateTO', style: 'btn-primary'})
              row.actions.push({text: 'Revisi', command: 'revisiTO', style: 'btn-success'})
            }

						context.pagination.totalPages = tryout.page
						context.tryouts.push(row)
					})
				}
			})
		},
		editTryout: function () {
			var tryoutId = this.selectedRow.id
			var context = this
			TryoutService.getTryoutById(tryoutId, function (result) {
				if (result.success) {
					context.$store.commit('tryout_init', result.data)
					context.$router.push({ path: 'tryout-form', query: { id: context.selectedRow.id } })
				}
			})
		},
		createTryout: function () {
			this.$store.commit('tryout_reset')
			this.$router.push({ path: '/tryout-form' })
		},
		importTryout: function () {
			this.$router.push({ path: '/tryout-import' })
		},
		exportTryout: function (event) {
			var tryoutId = event.id
			TryoutService.getTryoutById(tryoutId, function (result) {
				if (result.success) {
					delete result.data.id
					delete result.data.code
					delete result.data.group_id
					delete result.data.created_at
					delete result.data.updated_at
					delete result.data.page
					delete result.data.state
					delete result.data.bundle_code
					delete result.data.started_at
					delete result.data.ended_at
					delete result.data.completed_at
					delete result.data.completion_time
					delete result.data.correct
					delete result.data.wrong
					delete result.data.empty
					delete result.data.member_count
					delete result.data.display_name

					let subt = result.data.subtests
					if(subt.length > 0){
						for(var i = 0; i < subt.length; i++) {
							delete subt[i].id
							delete subt[i].created_at
							delete subt[i].updated_at
							delete subt[i].subtest_code
							if(subt[i].details.length > 0){
								var det = subt[i].details
								for(var b = 0; b < det.length; b++) {
									delete det[b].id
									delete det[b].created_at
									delete det[b].updated_at
								}
							}
						}
					}
					result.data.status = "DRAFT"
					let data = JSON.stringify([result.data])
					let blob = new Blob([data]);
					let link = document.createElement('a');
					link.href = window.URL.createObjectURL(blob);
					link.download = 'tryout_export_'+ new Date().getTime()+'.json'
					link.click()
				}
			})
		},
		generateTryout: function(event) {
			TryoutService.generateTryout(event.id, function (result) {
				if(result.success){
					alert('Generate tryout berhasil')
				} else if(result.message === 'Request failed with status code 404'){
					alert('Generate tryout gagal, data tidak ditemukan')
				} else if(result.message === 'Request failed with status code 406') {
					alert('Generate tryout gagal, set tryout telah mencapai batas maksimal (99)')
				}
			})
		},
    revisiTryout: function(event) {
      this.$router.push({ path: 'tryout-revisi', query: {id: event.id,}})
    }
	}
}
</script>



// WEBPACK FOOTER //
// Tryout.vue?07254fc6